export interface ProfilesEntity {
  auction: string
  deleted: unknown | null
  display_anonymous: boolean
  email: string
  email_invite_code: string
  first_name: string
  has_activity: boolean
  invite_email: string
  invite_phone_number?: string
  invite_state: InviteStateEnum
  is_active: boolean
  last_name: string
  phone_number: string
  phone_number_unsubscribed: string | null
  sms_invite_code: string
  stripe_customer: string | null
  table: string | null
  terms_and_conditions_accepted: boolean
  title: string | null
  uuid: string
  user?: string | null
  volunteer: boolean
  phone_number_verified_at: null
  has_payment_method: boolean
  email_verified_at: string | null
  preferred_contact: PreferredContactEnum
  paddle_number?: number | null
  is_email_unsubscribed: boolean
  is_blocked: boolean
}

export interface AuctionBlockListEntity {
  id: number
  created: string
  updated: string
  user: string | null
  user_id: number | null
  user_first_name?: string | null
  user_last_name?: string | null
  email_pattern: string | null
  email_domain: string | null
  phone_number: string | null
  reason: string | null
  blocked_by: number | null
  blocked_by_id: number | null
}

export enum PreferredContactEnum {
  Email = 'email',
  Phone = 'phone_number',
}

export enum InviteStateEnum {
  Complete = 'complete',
  None = 'none',
  Verified = 'verified',
  Sent = 'sent',
  Seen = 'seen',
  Cancelled = 'cancelled',
  Expired = 'expired',
}

export interface ProfileFilters {
  search?: string
  ordering?: string
  invite_state?: string[]
  team?: string | null
  exclude_team?: string | null
  user_null?: boolean
  user?: string
}

export interface ImportUsersResponse {
  users_count: number
  errors: string[]
  users: ProfilesEntity[]
}
